import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateItAdmin = createAsyncThunk('updateItAdmin', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + 'it_admin',
            data: data?.values,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
